export default __webpack_public_path__ + "static/media/Marianne-Regular_Italic.79ec1218.woff";